'use client';

import { ArrowLeft } from 'lucide-react';

/**
 * [DC01] Simple back button atomic component that takes a callback function
 */
interface BackButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
}

// Named export for better tree-shaking and explicit imports
export function BackButton({ onClick, label = 'Zurück', className = '' }: BackButtonProps) {
  // [CP01] Keep it simple
  return (
    <button
      onClick={onClick}
      className={`flex items-center text-blue-600 hover:text-blue-800 transition-colors ${className}`}
      aria-label={label}
    >
      <ArrowLeft className="w-4 h-4 mr-1" />
      {label && <span className="text-sm">{label}</span>}
    </button>
  );
}
